<script lang="ts" setup>
    import type { PropType } from "vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { getCtaLink } from "@/helpers/interfaces/Cta";
    import type { Cta } from "@/helpers/builder-init/index";

    interface AccordionItem {
        title: string;
        content: string;
    }

    interface AccordionDetail {
        items: AccordionItem[];
    }
    let props = defineProps({
        headline: {
            type: String,
            required: false
        },
        bgColor: {
            type: String,
            required: false,
            default: 'rothcoCream'
        },

        cta: {
            type: Object as PropType<Cta>,
            required: false
        },
        accordionDetails: {
            type: Array as PropType<AccordionItem[]>,
            required: true
        }
        
    })
</script>
<template>
    <div :class="`accordion-wrapper bg-${bgColor}`">
      <div class="accordion-header">
          <h2 class="accordion-header__title headline-xl">{{ headline }}</h2>
          <RothcoCta v-if="cta" v-bind="getCtaLink(props.cta)">
            {{ cta.label }}
          </RothcoCta>
        </div>
        <div :class="`accordion-container bg-${bgColor}`">
          <details class="accordion" v-for="(accordionDetail, index) of accordionDetails" :key="`detail-${index}`">
            <summary class="accordion__title">
              <h3 class="accordion__title-text paragraph-feature">{{ accordionDetail.title }}</h3>
            </summary>
            <div class="accordion__content">
              <div v-html="accordionDetail.content"></div>
            </div>
          </details>
          
          <div class="accordion__footer">
            <slot name="footer-content"></slot>
          </div>
        </div>
    </div>
</template>